export enum ETipoMenuItem {
    Padrao = 1,
    SubItem = 2,
    ItensAgrupadosLinhaInteira = 3,
    ItensAgrupadosPorColuna = 4,
}
